import { Identifiable, List, Milestone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function moveMilestone(httpClient: HttpClient) {
  return (
    milestone: Identifiable<Milestone>,
    parentList: Identifiable<List>,
    alignDates: boolean,
  ) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/projects/moveElement`,
        method: HttpMethods.POST,
        data: {
          elementUuid: milestone.uuid,
          projectEntityType: "MILESTONE",
          targetActivityUuid: parentList.uuid,
          conserveTime: !alignDates,
        },
      })
      .catch((e) => {
        return Promise.reject(
          mapError(e, {
            startDateOutOfBoundProject: "startDateOutOfBoundProject",
            startDateOutOfBound: "startDateOutOfBound",
            endDateOutOfBoundProject: "endDateOutOfBoundProject",
            endDateOutOfBound: "endDateOutOfBound",
          }),
        );
      });
}

export { moveMilestone };
